<div class="sdp-gateway-pending-container">
	<mat-card>
		<h4>
			{{ "gateways.pending.title" | translate }}
		</h4>
		<div *ngIf="!!pendingGatewaysData">
			<sdp-generic-table
				[columnSchema]="pendingColumnSchema"
				[tableName]="'Pending Gateways'"
				[tableData]="pendingGatewaysData"
				[rows]="5"
			></sdp-generic-table>
		</div>
		<ng-template #noResults>
			<div
				*ngIf="!errorMessage"
				class="sdp-sessions-no-records"
			>
				{{ "gateways.noResultsFound" | translate }}
			</div>
		</ng-template>
	</mat-card>
</div>